var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"bar","height":"350","options":this.chartOptions,"series":this.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }